import React from 'react';
import useTitle from 'hooks/useTitle';
import { useContextState } from 'context/context';
import UseCaseLayout from 'components/layouts/use-case';
import ContentCard from 'components/global/content-card';
import ConnectWallet from 'components/global/connect-wallet';
import ClaimHeader from './components/header';
import StakeMain from './components/main';
import ClaimTabs from './components/stake-tabs';

const ClaimPage: React.FunctionComponent = () => {
  const { connectedAccount } = useContextState();
  useTitle({ title: 'Claim GZen' });

  return (
    <UseCaseLayout activeKey="4" className="claim-container" style={{ maxWidth: 1036 }}>
      <ContentCard noPadding header={<ClaimHeader />}>
        <StakeMain />
        {connectedAccount ? (
          <ClaimTabs />
        ) : (
          <>
            <ConnectWallet className="stake-connect-wallet" />
            <div className="stake-wallet-desc">Connect your wallet to claim GZen tokens!</div>
          </>
        )}
      </ContentCard>
    </UseCaseLayout>
  );
};
export default ClaimPage;
